export default {
    manageAttendance: 'Manage Attendance',
    searchByEmployeeName: 'Search by Employee name, ID, Bureau',
    search: 'Search',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    bureau: 'Bureau',
    date: 'Date',
    checkIn: 'Check in',
    status: 'Status',
    action: '',
    congratulation: 'Congratulation',
    somethingWrong: 'Something went wrong'
}
